import { AssessmentCollectionLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Forms = [
  {
    fileStoreId: "1dcce24a-2d87-4c23-b9c0-640e453eebc9",
    label:
      "Schedule of Presentation/Rebate Dates of Property Tax (PD) Bills for the Year 2026-2027",
  },
  {
    fileStoreId: "11f0b992-6eb2-426b-b33e-f86cabeea320",
    label:
      "Schedule of Presentation/Rebate Dates of Property Tax (PD) Bills for the Year 2025-2026",
  },
  {
    fileStoreId: "858c9b1a-fbef-40f4-9720-87efaadd58b1",
    label:
      "Schedule of Presentation/Rebate Dates of Property Tax (PD) Bills for the Year 2024-2025",
  },
  {
    fileStoreId: "b9f68506-4070-470d-a2d2-d292a451639f",
    label:
      "Schedule of Presentation/Rebate Dates of Property Tax (PD) Bills for the Year 2023-2024",
  },
  {
    fileStoreId: "18017226-2a59-4f3c-8a94-891f18042026",
    label:
      "Schedule of Presentation/Rebate Dates of Property Tax (PD) Bills for the Year 2022-2023",
  },
  {
    fileStoreId: "18017326-2a59-4f3c-8a94-891f18042026",
    label:
      "Schedule of Presentation/Rebate Dates of Property Tax (PD) Bills for the Year 2021-2022",
  },
  {
    fileStoreId: "18017426-2a59-4f3c-8a94-891f18042026",
    label:
      "Schedule of Presentation/Rebate Dates of Property Tax (PD) Bills for the Year 2020-2021",
  },
  {
    fileStoreId: "18017526-2a59-4f3c-8a94-891f18042026",
    label:
      "Schedule of Presentation/Rebate Dates of Property Tax (PD) Bils for the Year 2019-2020",
  },
  {
    fileStoreId: "18017626-2a59-4f3c-8a94-891f18042026",
    label:
      "Schedule of Presentation/Rebate Dates of Property Tax (PD) Bils for the Year 2018-2019",
  },
  {
    fileStoreId: "18017726-2a59-4f3c-8a94-891f18042026",
    label:
      "Schedule of Presentation/Rebate Dates of Property Tax (PD) Bils for the Year 2017-2018",
  },
  {
    fileStoreId: "18017826-2a59-4f3c-8a94-891f18042026",
    label:
      "Kolkata Municipal Corporation(Preservation and Maintenance of Water Body) Regulations, 2016",
  },
  {
    fileStoreId: "06cde3a0-2c68-4729-b7aa-3b6bf63d8a2f",
    label:
      "Kolkata Municipal Corporation(Fast Track Settlement Committee) Regulations, 2015",
  },
  {
    fileStoreId: "18018026-2a59-4f3c-8a94-891f18042026",
    label: "Presentation/Rebate date schedule for PD Bill 2016-17",
  },
  {
    fileStoreId: "18018126-2a59-4f3c-8a94-891f18042026",
    label: "Presentation/Rebate date schedule for PD Bill 2015-16",
  },
  {
    fileStoreId: "18018226-2a59-4f3c-8a94-891f18042026",
    label: "Presentation/Rebate date schedule for PD Bill 2014-15",
  },
  {
    fileStoreId: "a6abd3a1-fa95-40e7-9576-fc1bab3a673f",
    label: "List of Recently Exempted Premises",
  },
  {
    fileStoreId: false,
    label:
      "List of Counters (Common Collection Centres/Treasury Counters/Banks) for collection of PD Bills",
  },
  {
    fileStoreId: "18018426-2a59-4f3c-8a94-891f18042026",
    label: "Citizen Handbook",
  },
];

const Assessment_collection_Message_Board = () => (
  <TableStructure
    title="Message Board"
    heading={"Messages"}
    list={Forms}
    leftMenuList={AssessmentCollectionLeftMenuList}
  />
);

export default Assessment_collection_Message_Board;
